export enum RoutesEnum {
  Login = '/',
  SignUp = '/signup',
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password',
  Settings = '/settings',
  TermsConditions = '/terms-conditions',
  PrivacyPolicy = '/privacy-policy',
  ConfirmAccount = '/confirm-account',
  VerifyMagicLink = '/verify-magic-link',
  MagicLinkSessionExpired = '/magic-link-expired',
  LoginMagicLink = '/login-magic-link',
  Support = '/support',
  Opportunities = '/opportunities',
  FileManager = '/filemanager'
}
